// navAnalytics.ts — CORE-1277
//
// Одна-единственная отправка `header_nav_clicked` на всё приложение.
//
// ── Зачем отдельный файл ради одной строки ──────────────────────────────────
// Глобальная навигация в дереве живёт в четырёх местах: горизонтальная шапка и
// встроенный в неё мобильный ящик (`Header.tsx`), отдельная копия ящика для
// нативных экранов (`MobileNavMenu.tsx`) и подвал (`Footer.tsx`). Событие у них
// одно, а разметку CORE-1277 при первом заходе получили только три из четырёх:
// копия ящика внутри `Header.tsx` продолжала слать голый `destination`, и на
// вебе при 390×844 — единственной поверхности, где она вообще открывается, —
// весь мобильный трафик приходил в цели без места клика (QA FAIL 04.09).
//
// Пропуск был невидим именно потому, что отправка копировалась: каждое место
// звало `analytics.track` со своим объектом свойств, и «забыть поле» стоило
// ровно ничего. Здесь `surface` обязателен по типу — новая копия меню либо
// назовёт своё место, либо не соберётся.
//
// Слой остаётся тонким поверх внутренней `AnalyticsEvents` — ни нового имени
// события, ни второго потока, как и в `homeAnalytics.ts` (CORE-595). Внешние
// цели читают это же событие правилами из `marketingTags.ts`.

import { analytics } from './analytics';
import type { NavSurface } from './marketingTags';

/**
 * Имя внутреннего события. Историческое «header_» шире своей шапки: тем же
 * именем считаются переходы из подвала и из меню, и переименование стоило бы
 * разрыва ряда в дашборде — место клика различает `surface`, а не имя.
 */
export const NAV_CLICK_EVENT = 'header_nav_clicked';

/**
 * Глобальный переход в раздел.
 *
 * @param destination имя маршрута навигации (`Lives`, `Practices`, `Masters`,
 *   `MyCalendar`) — то же, что уходит в `navigation.navigate`.
 * @param surface откуда нажали. Обязателен: цели «Календарь», «Практики» и
 *   «Мастера» одни на все поверхности, и разрез по месту — единственное, чем
 *   мобильный клик отличается от десктопного.
 */
export function trackNavClicked(destination: string, surface: NavSurface): void {
  analytics.track(NAV_CLICK_EVENT, { destination, surface });
}
